// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1hWnt";
var _3 = "carry_on-ejEuO";
var _4 = "small-3UzDt";
var _5 = "size-2F3ev";
export { _1 as "__esModule", _2 as "root", _3 as "carry_on", _4 as "small", _5 as "size" }
export default { "__esModule": _1, "root": _2, "carry_on": _3, "small": _4, "size": _5 }
